import {FeatureCollection} from '@turf/turf';
import {getCameraBoundingBox, toIGNBBoxString} from '../../cesiumTools';
import {LayerDatasource, LayerLoadType, MapperViewer} from '../../types';

export class RailwayLayer implements LayerDatasource {

  id = 'railway';
  name = 'Voies ferrées';
  active = false;
  dataSource = new Cesium.GeoJsonDataSource(this.name);
  loadType = LayerLoadType.Manual;
  viewer: MapperViewer;
  showLabel = false;
  isLoading = false;

  url = 'https://data.geopf.fr/wfs?version=2.0.0&SERVICE=WFS&REQUEST=GetFeature&OUTPUTFORMAT=json&TYPENAME=BDTOPO_V3:troncon_de_voie_ferree&BBOX=';

  previouslyLoadedBbox = null;

  constructor() {}

  onBeforePrint(): void {

  }
  onAfterPrint(): void {

  }

  initialize(viewer: MapperViewer): void {
    this.viewer = viewer;
    viewer.dataSources.add(this.dataSource);
  }

  remove(): void {
    this.viewer.dataSources.remove(this.dataSource);
  }

  loadData(forceReload = false): void {
    if (!this.dataSource) {
      console.error('Viewer not initialized');
      return;
    }

    const bbox = toIGNBBoxString(getCameraBoundingBox(this.viewer));

    if (this.previouslyLoadedBbox === bbox && !forceReload) {
      return;
    }

    this.previouslyLoadedBbox = bbox;

    if (bbox) {
      this.isLoading = true;

      const url = `${this.url}${bbox}`;
      fetch(url)
        .then(res => res.json())
        .then((geojson: FeatureCollection) => {
          this.buildRailway(geojson);
        }).catch(error => {
          console.error('[RailwayLayer] -> (error) -> ', error);
          this.isLoading = false;
        });
    }
  }

  buildRailway(res: FeatureCollection): void {
    this.dataSource.load(res, {
      clampToGround: true,
    }).then(() => {
      this.dataSource.entities.values.forEach(entity => {
        if (entity.polyline) {
          entity.polyline.material =  new Cesium.PolylineOutlineMaterialProperty({
            color: Cesium.Color.BROWN.withAlpha(0.8),
            outlineColor: Cesium.Color.BLACK.withAlpha(0.8),
            outlineWidth: 1
          });
          entity.polyline.width = new Cesium.ConstantProperty(5);
        }
      });

      this.setActive(true);
      this.isLoading = false;
    });
  }

  setActive(active: boolean): void {
    this.active = active;
    this.dataSource.show = active;

    if (active) {
      this.loadData();
    }
  }
}
